export default __webpack_public_path__ + "static/media/inbox.a8fd99b4.svg";